module.exports = __webpack_public_path__ + "img/download-times.c6cc5537.svg";